<template>
    <div>
        <v-row class="align-left mx-2">
            <h1>Picklist History</h1>
            <p>This shows the most recently dispatched PickLists, including completed ones.</p>
        </v-row>
        <!--Items begin-->
        <!--v-on:click="findSub(item)" (maybe next year)-->
        <v-card v-for="pickList in pickLists" v-bind:key="pickList.orderNumber" class="mb-6 mt-6 py-8 px-2" v-on:click="confirmDispatch(pickList.orderNumber)">
            <v-row justify="center" class="d-flex">
                <v-col cols="9" class="pb-0 pl-6 pt-0 align-left" align-self="center">
                    <v-row>
                        <v-col cols="12" class="pb-0 pt-2 pr-0 pl-0">
                            <p class="mb-title item-title text-h5">{{ pickList.orderNumber }}</p>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" class="pb-0 pt-0 pr-0 pl-0">
                            <strong class="text-h5">{{ pickList.order.customer.name }}</strong>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="3" class="pb-0 pr-6 pt-0 align-left">
                    <strong>Picked by {{ getPickers(pickList.pickers) }}</strong>
                </v-col>
            </v-row>
        </v-card>

    </div>
</template>
    
<script>
import moment from 'moment'

import axios from 'axios'
import vars from "@/assets/scripts/vars.js"

export default {
    name: 'RecentPickLists',
    data: () => {
        return {
            pickLists: [],
        }
    },
    components: {
        
    },
    computed: {

    },
    beforeMount() {
        this.$store.commit("setTitle", "Picklist History")
        this.$store.commit("enableNavbar", "true")
        this.$store.commit("setActionText", "")
    },
    mounted() {
        this.$store.commit("setLoading", true)
        this.getRecentPickLists()
    },
    methods: {
        getPickers: function(pickers){
            if(pickers.length === 0){
                return "???"
            }

            let str = ""
            pickers.forEach(picker => {
                str += picker.picker.fullName
                if(picker !== pickers[pickers.length - 1]){
                    str += ", "
                }
            })
            return str
        },
        getFormattedDate(date){
            return moment(date).format("Do HH:mm")
        },
        getItemTitle: function(lineNumber){
            return this.$store.state.stock[lineNumber].title
        },
        getRecentPickLists() {
            axios({
                "method": "GET",
                "url": vars.apiURL + "picklist/getRecent/" + this.$store.state.user.branch,
                "headers": {
                    "Authorization": "Bearer " + this.$store.state.user.access_token
                }
            }).then((data) => {
                this.pickLists = data.data
                this.$store.commit("setLoading", false)

            }).catch((error) => {
                console.log(error)
            })
        },
        confirmDispatch(orderNumber) {
            //this.$store.commit("setLoading", true)
            //Get order
            let order = this.$store.state.orders[orderNumber]

            // Now load order review screen
            this.$store.commit("setActiveOrder", order);
            this.$router.push({ name: 'OrderReview' })
        }
    }
}
</script>
    